module.exports = __webpack_public_path__ + "static/media/camera.101613ec.svg";